import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import moment from 'moment';
import DatePicker from 'vue2-datepicker'
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'ReversePassQC',
  components: {
    VueElementLoading,
    Treeselect,
    Paginate,
    DatePicker
  },
  mixins:[PageTracker],
  data: function() {
    return {
      fromDate: '',
      toDate: '',
      shippingID: '',
      fetcheddata: [],
      pageno: 1,
      pagecount: 0,
      username: '',
      hubId: '',
      totalRecords: 0,
      isLoading: false,
      listCount: 20,
      showSearchForm: false,
      plus: true,
      minus: false,
      comment: '',
      upshippingID: '',
      isLoad: false,
      userDataKey : '',
    }
  },
  created: function() {},
  filters: {
    dateformat: function(val) {
      if (val == null) return ''
      return moment(val).format('DD-MM-YYYY');
    }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.username = userdetail.username;
    this.localuserid =  userdetail.userid
    this.hubId = userdetail.hubdetails[0]
    this.localuserid =  userdetail.userid
    this.searchdata();

    // let TrackerInfo = {
    //     projectname:"Last Mile",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.username,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
  },
  methods: {
    // showupdate() {
    //   // this.showSearchForm = false;
    //   if (this.showUpdateForm == false) {
    //     this.showUpdateForm = true;
    //     this.plusIcon = false;
    //     this.minusIcon = true;
    //   } else {
    //     this.showUpdateForm = false;
    //     this.plusIcon = true;
    //     this.minusIcon = false;
    //   }
    // },
    showsearch() {
      if (this.showSearchForm == false) {
        this.minus = true;
        this.plus = false;
        this.showSearchForm = true;
      } else {
        this.plus = true;
        this.minus = false;
        this.showSearchForm = false
      }
    },
    updateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.update();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    update() {
      this.input = {
        "ShippingID": this.upshippingID.trim(),
        "LastModifiedBy": this.username,
        "Comments": this.comment
      }
      this.isLoad = true;
      axios.post(apiUrl.api_url + 'external/updateisescalatedqcforlastMile', this.input)
        .then((response) => {
          if (response.data.code === 200) {
            this.$alertify.success(response.data.message);
            this.isLoad = false;
            this.searchdata();
            this.clear();
          } else {
            this.isLoad = false;
            this.$alertify.error(response.data.message);
          }
        }).catch(() => {
          console.log('errors exist', this.errors)
        });
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.searchdata();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getShipmentList() {
      this.input = {
        "HubId": this.hubId,
        "PageNo": this.pageno
      }
      if (this.fromDate) {
        let fdate =  moment(this.fromDate).format('YYYY-MM-DD');
        this.input.FromDate = fdate
      }
      if (this.toDate) {
        let tdate =  moment(this.toDate).format('YYYY-MM-DD');
        this.input.ToDate = tdate
      }
      if (this.shippingID) {
        this.input.ShippingId = this.shippingID.trim()
      }
      this.isLoading = true
      axios.post(apiUrl.api_url + 'external/getHubShipmentdetails/byHubId', this.input)
        .then((response) => {
          if (response.data.code === 200) {
            this.isLoading = false
            this.fetcheddata = response.data.ShipmentDetails;
            this.totalRecords = response.data.TotalCount;
            this.pagecount = Math.ceil(this.totalRecords / this.listCount)
          } else {
            this.fetcheddata = [];
            this.totalRecords = 0
            this.pagecount = 0
            this.isLoading = false
            this.$alertify.error(response.data.data.ReturnMessage);
          }
        }).catch(() => {
          console.log('errors exist', this.errors)
        });
    },
    searchdata() {
      this.pageno = 1;
      this.$refs.paginate.selected = 0;
      this.getShipmentList();
    },
    getPaginationData(pageNum) {
      this.pageno = pageNum;
      this.getShipmentList();
    },
    reset() {
      this.fromDate = ''
      this.toDate = ''
      this.shippingID = ''
      this.fetcheddata = [];
      this.totalRecords = 0
      this.pagecount = 0
      this.isLoading = false
    },
    clear() {
      this.$validator.reset();
      this.upshippingID = ''
      this.comment = ''
      this.isLoad = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ReversePassQC/ReversePassQC.component.js